import { gql } from '@apollo/client';

export const GET_FILES_FOR_PROJECT = gql`
    query getFilesForProject($input : GetFileInfoInput) {
        getFilesForProject(input : $input) {
            fileId
            fileName
            fileDisplayName
            noOfRecords
            noOfColumns
            columnDetails
            projectId
        }
    }
`;

export const GET_RECON_FUNCTIONS = gql`
    query getReconFunctions($input : GetReconFunctionsInput) {
        getReconFunctions(input : $input) {
            functionId
            functionName
            functionDescription
            isPreview
        }
    }
`;

export const GET_COLUMNS_FOR_FILE = gql`
    query getColumnsForFile($input : GetColumnsInfoInput) {
        getColumnsForFile(input : $input) {
            name
            dataType
        }
    }
`;

export const GET_FILTER_FUNCTIONS = gql`
    query getReconFunctions($input : GetReconFunctionsInput) {
        getReconFunctions(input : $input) {
            functionId
            functionName
            functionDescription
            isPreview
        }
    }
`;

export const GET_SUB_PROJECTS = gql`
    query getChildProjectsConfiguration($input : GetChildProjectConfigInput) {
        getChildProjectsConfiguration(input : $input) {
            childProjConfig {
                projectId
                projectName
                flowConfig
                reconRunStatus
                projectDisplayId
                diagramFlow
            }
        }
    }
`;

export const RUN_RECONCILIATION_STATUS = gql`
    query getCurrentReconStatus($input : GetReconResultStatusInput) {
        getCurrentReconStatus(input : $input){
            reconStatusInPercent
            reconRunStatus
            failureReason
        }
    }
`;

export const GET_RECON_RESULT_TABLE_DATA = gql`
    query getReconResultTableData($input : ReconResultTableInput) {
        getReconResultTableData(input : $input){
            successBatchTests {
                sourceFileName
                targetFileName
                sourceColumn
                targetColumn
                sourceAggregatedOn
                targetAggregatedOn
                sourceTransactionAmount
                targetTransactionAmount
                delta
                batchId
                batchStartTime
                exceptionType
                nodeId
            }
            exceptionBatchTests {
                sourceFileName
                targetFileName
                sourceColumn
                targetColumn
                sourceAggregatedOn
                targetAggregatedOn
                sourceTransactionAmount
                targetTransactionAmount
                delta
                batchId
                batchStartTime
                exceptionType
                nodeId
            }
        }
    }
`;

export const GET_RECON_USER_COMMENTS = gql`
    query getReconUserComments($input : GetReconUserCommentInput ) {
        getReconUserComments(input : $input){
            commentText
            commentId
            userId
            createdAt
            firstName
            lastName
            initials
        }
    }
`;

export const GET_RECON_NODE_LIST = gql`
    query getReconOperationNodesList($input : GetNodesListInput ) {
        getReconOperationNodesList(input : $input){
            nodeId
            operation
            projectId
            batchStatus
        }
    }
`;

export const GET_PROJECT_CONFIGURATION = gql`
    query getChildProjectsConfiguration($input : GetChildProjectConfigInput) {
        getChildProjectsConfiguration(input : $input) {
            projectConfig {
                projectId
                projectName
                flowConfig
                reconRunStatus
                diagramFlow
                selectedColumnsData
                updatedAt
                projectDisplayId
            }
        }
    }
`;

export const GET_FILE_DATA = gql`
    query getPreviewDataOfFile($input : GetPreviewDataOfFileInput) {
        getPreviewDataOfFile(input : $input)
    }
`;

export const GET_FILTERED_FILE_DATA = gql`
    query getFilterPreviewData($input : GetFilterPreviewDataInput) {
        getFilterPreviewData(input : $input)
    }
`;
